import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "SL_classify_composer_body" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "SL_classify_composer_buttonBody" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "SL_classify_composer_userName" }

import { ref, reactive } from "vue";
import com_date from "@/assets/js/common.js";


export default /*@__PURE__*/_defineComponent({
  __name: 'moduleHotComposerQd',
  props: {
  item: { type: Object, default: "" },
},
  setup(__props) {

const yyy = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("view", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        class: "SL_classify_composer_topImg",
        src: __props.item.backImage ? __props.item.backImage : require('../assets/LS3.png')
      }, null, 8, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          class: "SL_classify_composer_userImg",
          src: __props.item.avatar ? __props.item.avatar : require('../assets/logo.png')
        }, null, 8, _hoisted_4),
        _createElementVNode("p", _hoisted_5, _toDisplayString(__props.item.nickName ? __props.item.nickName : __props.item.userName), 1)
      ])
    ])
  ]))
}
}

})